// DetailCard.js
import { details as dStyles } from "../styles/ChallanStyles";

// Icons (use whatever SVG/icon components you already have)
import { UserIcon, ShieldIcon, CalendarIcon, TruckIcon } from "./SvgIcons";

// Map the raw API object → the 4 detail cards shown in the screenshot
const buildDetails = (info) => [
    {
        icon: <UserIcon />,
        label: "ASSIGNED TO",
        value: info.driverName,                     
        sub: info.beatNames,                       
    },
    {
        icon: <ShieldIcon />,
        label: "CREATED BY",
        value: info.stockStakeHolderOwnerName,      
        sub: info.insertedDateTime,              
    },
    {
        icon: <CalendarIcon />,
        label: "EXPECTED CLOSE",
        value: info.settleDate ?? info.date,        
        valueColor: info.settleDate ? undefined : "red", 
        sub: info.isSettele === 0 ? "Not yet settled" : "Settled",
    },
    {
        icon: <TruckIcon />,
        label: "ASSIGNED VEHICLE",
        value: info.vehicleNo,                   
        sub: info.driverContactNo,                 
    },
];

export const DetailCard = ({ detail }) => {
    // detail is now the inDetailInfo object directly
    const cards = buildDetails(detail);

    return (
        // Single flex row — all cards share fixed width/height; row scrolls on narrow screens
        <div style={dStyles.row}>
            {cards.map((item, i) => (
                <div key={i} style={dStyles.card}>
                    <div style={dStyles.header}>
                        <div style={dStyles.iconWrapper}>{item.icon}</div>
                        <div style={dStyles.content}>
                            <div style={dStyles.label}>{item.label}</div>
                            <div style={dStyles.value(item.valueColor)}>
                                {item.value}
                            </div>
                            {item.sub && <div style={dStyles.sub}>{item.sub}</div>}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};